
define('ldsh!modules/form_editor/templates/editor_custom_iban', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showBBAN) { ;
__p += '\n<div class="ed-form-group">\n  <div class="md__checkbox--wrapper">\n     <input\n      id="allow-BBAN"\n      type="checkbox"\n      class="md__checkbox--primary js-filter-hidden js-bban"\n      ' +
((__t = ( allowBBAN ? 'checked' : '' )) == null ? '' : __t) +
'\n    />\n    <label\n      for="allow-BBAN"\n      data-i18n="formEditor.allowBBAN"\n    ></label>\n  </div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

